module.exports = __webpack_public_path__ + "img/banner-en10x20.1401410c.jpg";